import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import AlertConfirm from "../modals/Confirm";
import Select from "react-select";

class OtherMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            toOpenFemaleQues:false,
            recommendationLetter:false,
            psychiatricDiagnosis:false,
            cardioVascular:false,
            activePsychosis:false,
            sychiatricFirstDegree:false,
            drugAddictionHistory:false,
            pastPsychoticCondition:false,
            lungDisease:false,
            cardioVascularEvent:false,
            pregnant:false,
            breast_feeding:false,
            psychiatric_diagnose_icd:this.props.psychiatric_diagnose_icd,
        }
    }
    componentDidMount() {
        this.setState({recommendationLetter: this.state.entry.Recommendation_letter_use_cannabis==="Yes"})
        this.setState({psychiatricDiagnosis: this.state.entry.Psychiatric_diagnosis==="Yes"})
        this.setState({psychiatristConfirmation: this.state.entry.Psychiatrist_confirmation==="Yes"})
        this.setState({cardioVascular: this.state.entry.Cardiovascular_history==="Yes"})
        this.setState({cardioVascularEvent: this.state.entry.Cardiovascular_risk==="Yes"})
        this.setState({psychiatricFirstDegree: this.state.entry.Nuclear_family_psychosis==="Yes"})
        this.setState({pastPsychoticCondition: this.state.entry.Past_psychosis==="Yes"})
        this.setState({activePsychosis: this.state.entry.Current_psychosis==="Yes"})
        this.setState({drugAddictionHistory: this.state.entry.Drug_abuse==="Yes"})
        this.setState({lungDisease: this.state.entry.Lung_disease==="Yes"})
        this.setState({pregnant: this.state.entry.Pregnant==="Yes"})
        this.setState({breast_feeding: this.state.entry.Breast_feeding==="Yes"})


    }
    onClickRecommendationLetter(event){
        this.setState({recommendationLetter: event === "Yes"})
        this.props.onValueChange("Recommendation_letter_use_cannabis", event)
    }
    onClickPsychiatricDiagnosis(value){
        this.props.onYesNoValueChange("Psychiatric_diagnosis", value)
        if(value==="No" ||value==="Unknown"){
            this.props.onValueChange("psychiatric_diagnoses_icd_name", "")
            this.props.onValueChange("psychiatric_diagnoses_icd_code", "")

        }

    }
    onClickActivePsychosisConfirmation(event){
        this.setState({activePsychosis: event.target.value === "Yes"})
        this.props.onValueChange("Current_psychosis", event.target.value)
    }
    onClickPastPsychoticConditionConfirmation(event){
        this.setState({pastPsychoticCondition: event.target.value === "Yes"})
        this.props.onValueChange("Past_psychosis", event.target.value)
    }
    onClickPsychiatricFirstDegreeConfirmation(event){
        this.setState({psychiatricFirstDegree: event.target.value === "Yes"})
        this.props.onValueChange("Nuclear_family_psychosis", event.target.value)
    }
    onClickDrugAddictionHistoryConfirmation(event){
        this.setState({drugAddictionHistory: event.target.value === "Yes"})
        this.props.onValueChange("Drug_abuse", event.target.value)
    }
    onClickCardioVascular(event){
        this.setState({cardioVascular: event.target.value === "Yes"})
        this.props.onValueChange("Cardiovascular_history", event.target.value)
    }
    onClickCardioVascularEvent(event){
        this.setState({cardioVascularEvent: event.target.value === "Yes"})
        this.props.onValueChange("Cardiovascular_risk", event.target.value)
    }
    onClickLungDisease(event){
        this.setState({lungDisease: event.target.value === "Yes"})
        this.props.onValueChange("Lung_disease", event.target.value)
    }

    async onClickSendAlert() {
        let {t} = this.props
        let message = t('patient_boarding.Consider_Continue_boarding')
        let confirm = await AlertConfirm({
            options: {
                title: ``,
            }
        }, message)
    }

    async onClickCardiologConfirmation() {
        let {entry} = this.state
        this.props.onYesNoValueChange("Cardiolog_confirmation", "No")
        if(entry['Cardiolog_confirmation']==="No"){
            this.onClickSendAlert()
        }    }

    async onClickPulmonaryConfirmation() {
        let {entry} = this.state
        this.props.onYesNoValueChange("Pulmonary_confirmation", "No")
        if(entry['Pulmonary_confirmation']==="No"){
            this.onClickSendAlert()
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }
    async onClickPsychiatristConfirmation() {
        let {entry} = this.state
        this.props.onYesNoValueChange("psychiatristConfirmation", "No")
        if(entry['psychiatristConfirmation']==="No"){
            this.onClickSendAlert()
        }
    }

    onChangeDiagnose(value,name,code,other){
        let {psychiatric_diagnose_icd} = this.state
        this.props.onValueChange(name, value)
        if(value.label === "OTHER"){
            this.props.onValueChange(code, "")
        }else{
            this.props.onValueChange(other, "")
            for(let i=0;i<psychiatric_diagnose_icd.length;i++){
                let diagnose=psychiatric_diagnose_icd[i]
                if(diagnose.Diagnosis_description === value.label){
                    this.props.onValueChange(code, diagnose.Diagnosis_code)
                }
            }
        }

    }
    onChangeDiagnose(option,name,code,another){
        let {psychiatric_diagnose_icd} = this.state
        this.props.onValueChange(name, option)
        if (option.value === 156) {
            this.props.onValueChange(code, "")
        }else{
            this.props.onValueChange(another, "")
            for(let i=0;i<psychiatric_diagnose_icd.length;i++){
                let diagnose=psychiatric_diagnose_icd[i]
                if(diagnose.Diagnosis_description === option.label){
                    this.props.onValueChange(code, diagnose.Diagnosis_code)
                }
            }
        }
    }

    onChangeDiagnoseCode(value,name,code){
        this.props.onValueChange(name, value)
        let {psychiatric_diagnose_icd} = this.state
        let isUpdated=0
        let otherVariable
        for (let i = 0; i < psychiatric_diagnose_icd.length; i++) {
            let diagnose = psychiatric_diagnose_icd[i]
            if (diagnose.ICD_diagnosis_id === 156) {
                otherVariable={value:diagnose.Diagnosis_code,label:diagnose.Diagnosis_description}
            }
            if (diagnose.Diagnosis_code === value) {
                this.props.onValueChange(code, {value:diagnose.Diagnosis_code,label:diagnose.Diagnosis_description})
                isUpdated+=1
            }
        }
        if(isUpdated===0){
            this.props.onValueChange(code, otherVariable)
        }
    }

    handlePsychiatricDiagnoseChange(option) {
        this.onChangeDiagnose(option,"psychiatric_diagnoses_icd_name","psychiatric_diagnoses_icd_code","other_psychiatric_diagnoses")
    }

    render() {
        let {t} = this.props

        let {entry,psychiatric_diagnose_icd}= this.state
        /*
                let psychiatric_diagnose=[]

                psychiatric_diagnose = psychiatric_diagnose_icd.map(item =>
                    <option className={'option-style'} value={item.Diagnosis_description}>{item.Diagnosis_description}</option>)
        */

        let psychiatric_diagnose=[psychiatric_diagnose_icd.length]
        for(let i=0;i<psychiatric_diagnose_icd.length;i++){
            psychiatric_diagnose[i]={value:psychiatric_diagnose_icd[i].ICD_diagnosis_id, label:psychiatric_diagnose_icd[i].Diagnosis_description}
        }
        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} id={'drug'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Hospitalizations_last_year')}?</label>
                        </div>

                        <button tabIndex={0}  className={entry.Hospitalizations_last_year==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Hospitalizations_last_year==="No"? 'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0} className={entry.Hospitalizations_last_year==="Unknown"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Psychiatric_diagnosis')}?*</label>
                            <Error isShown={!!(this.props.errors)['Psychiatric_diagnosis']} errorMessage={(this.props.errors)['Psychiatric_diagnosis']}/>
                        </div>

                        <button tabIndex={0}  className={entry.Psychiatric_diagnosis==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onClickPsychiatricDiagnosis("Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Psychiatric_diagnosis==="No"? 'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.onClickPsychiatricDiagnosis("No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0} className={entry.Psychiatric_diagnosis==="Unknown"?  'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onClickPsychiatricDiagnosis("Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                </div>

                <div className={'patientsFormRow'} style={{display:entry.Psychiatric_diagnosis==="Yes"?'flex':'none'}}>
                    <div className={'inputSlotsHalfBlock-icd'}>
                        <label className={'infoLabel'}>{t('patient_boarding.psychiatric_diagnoses_icd_name')}</label>
                        <PatientSelectComponent
                            selectWidth={'700px'}
                            placeholder={t('patient_boarding.icd_psyc_choose')}
                            options={psychiatric_diagnose}
                            value={entry.psychiatric_diagnoses_icd_name}
                            onChange={this.handlePsychiatricDiagnoseChange.bind(this)}
                        />
                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.psychiatric_diagnoses_icd_code')}</label>
                        <input className={'inputBoxStyle'} name="psychiatric_diagnoses_icd_code" value={entry.psychiatric_diagnoses_icd_code}
                               onChange={(event) => this.onChangeDiagnoseCode(event.target.value,event.target.name,"psychiatric_diagnoses_icd_name")}/>
                    </div>

                    <div className={'inputSlots'} style={{display:entry.psychiatric_diagnoses_icd_name&&entry.psychiatric_diagnoses_icd_name.value===156?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_boarding.other')}</label>
                        <input className={'inputBoxStyle'} name="psychiatric_diagnoses_icd_code" value={entry.other_psychiatric_diagnoses}
                               onChange={(event) => this.props.onValueChange("other_psychiatric_diagnoses",event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>

                            <label className={'infoLabel-withError'}>{t('patient_boarding.psychosis')}?*</label>

                            <Error isShown={!!(this.props.errors)['Current_psychosis']} errorMessage={(this.props.errors)['Current_psychosis']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Current_psychosis==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Current_psychosis", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Current_psychosis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Current_psychosis", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>

                    </div>
                </div>
                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Past_psychosis')}?*</label>
                            <Error isShown={!!(this.props.errors)['Past_psychosis']} errorMessage={(this.props.errors)['Past_psychosis']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Past_psychosis==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Past_psychosis", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Past_psychosis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Past_psychosis", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>

                    </div>

                </div>
                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Nuclear_family_psychosis')}?*</label>
                            <Error isShown={!!(this.props.errors)['Nuclear_family_psychosis']} errorMessage={(this.props.errors)['Nuclear_family_psychosis']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Nuclear_family_psychosis==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Nuclear_family_psychosis", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Nuclear_family_psychosis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Nuclear_family_psychosis", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>

                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Drug_abuse')}?* </label>
                            <Error isShown={!!(this.props.errors)['Drug_abuse']} errorMessage={(this.props.errors)['Drug_abuse']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Drug_abuse==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Drug_abuse", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Drug_abuse==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Drug_abuse", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} style={{ display: (
                            entry.Current_psychosis==="Yes"
                            || entry.Nuclear_family_psychosis==="Yes"
                            || entry.Drug_abuse==="Yes"
                            || entry.Past_psychosis==="Yes")
                            ?'flex': 'none' }}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.psychiatristConfirmation')}?</label>
                        </div>
                        <button tabIndex={0}  className={entry.psychiatristConfirmation==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("psychiatristConfirmation", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.psychiatristConfirmation==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) =>this.onClickPsychiatristConfirmation()}
                        >{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.cardiovascularHistory')}?* </label>
                            <Error isShown={!!(this.props.errors)['Cardiovascular_history']} errorMessage={(this.props.errors)['Cardiovascular_history']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Cardiovascular_history==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiovascular_history", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Cardiovascular_history==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiovascular_history", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.cardiovascularEvent')}?* </label>
                            <Error isShown={!!(this.props.errors)['Cardiovascular_risk']} errorMessage={(this.props.errors)['Cardiovascular_risk']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Cardiovascular_risk==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiovascular_risk", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Cardiovascular_risk==="No"? 'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiovascular_risk", "No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0} className={entry.Cardiovascular_risk==="Unknown"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiovascular_risk","Unknown")}>{t('patient_boarding.Unknown')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} style={{ display: entry.Cardiovascular_risk==="Yes" ||entry.Cardiovascular_history==="Yes" ?'flex': 'none' }}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Cardiolog_confirmation')}? </label>
                        </div>
                        <button tabIndex={0}  className={entry.Cardiolog_confirmation==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Cardiolog_confirmation", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Cardiolog_confirmation==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) =>this.onClickCardiologConfirmation()}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Lung_disease')}?* </label>
                            <Error isShown={!!(this.props.errors)['Lung_disease']} errorMessage={(this.props.errors)['Lung_disease']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Lung_disease==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Lung_disease", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Lung_disease==="No"?  'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Lung_disease", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} style={{ display: entry.Lung_disease==="Yes" ?'flex': 'none' }}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Pulmonary_confirmation')}? </label>
                        </div>
                        <button tabIndex={0}  className={entry.Pulmonary_confirmation==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Pulmonary_confirmation", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Pulmonary_confirmation==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) =>this.onClickPulmonaryConfirmation()}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'blankSpace'}/>
            </div>

        )
    }
}

OtherMedicalInfo.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default OtherMedicalInfo;
